import React from 'react'

import {
  Box,
  FormControl,
  MenuItem,
  Select,
  withStyles,
} from '@material-ui/core'
import { style } from './style'

const SelectWithLabel = ({
  classes,
  onChange,
  options,
  value,
  label,
  className: classNameProp,
  column,
  disabled = false,
}) => {
  return (
    <div
      className={`${
        column ? classes.selectorWrapperColumn : classes.selectorWrapperRow
      } ${classNameProp ? classNameProp : ''}`}
    >
      <Box className={classes.label}>{label}</Box>
      <FormControl margin="dense" className={column ? classes.selector : ''}>
        <Select
          value={value}
          onChange={event => onChange(event.target.value)}
          variant="outlined"
          disabled={disabled}
        >
          {options.map(option => (
            <MenuItem key={option.label} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  )
}

export default withStyles(style)(SelectWithLabel)
